import moment from 'moment-timezone';

import { badEmailCharacters } from 'common-src/constants/badEmailCharacters';
import { badNameCharacters } from 'common-src/constants/badNameCharacters';

export const isEmailValid = (email) =>
  email &&
  !badEmailCharacters.split('').some((char) => email.includes(char)) &&
  email.includes('@');

export const isPhoneStringValid = (phone) => /[0-9]{10}/.test(phone);

export const isNPIValid = (npi) => /^[0-9]{10}$/.test(npi);

export const validateStartEndDates = (startDate, endDate) => {
  let message = '';
  if (startDate && endDate && moment(startDate).isAfter(endDate)) {
    message = 'End date should be after start date';
  }

  return {
    endDate: message,
  };
};

export const isNumberValid = (str) => {
  const numberValue = Number(str);

  return (
    !str ||
    (str.length === 1 && numberValue === 0) ||
    (str.match(/[0-9]+/g) && !str.startsWith('00') && !Number.isNaN(numberValue))
  );
};

export const isMBIValid = (mbi) =>
  /\d(?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z\d]\d(?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z\d]\d(?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z]\d{2}$/.test(
    mbi,
  );

export const isNameValid = (name) =>
  !badNameCharacters.split('').some((char) => name.includes(char));

export const MAX_SMS_MESSAGE_LENGTH = 1600;

const GSM_7_BASIC_CHARS =
  '@\u00A3$\u00A5\u00E8\u00E9\u00F9\u00EC\u00F2\u00C7\n\u00D8\u00F8\r\u00C5\u00E5\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039E\u00C6\u00E6\u00DF\u00C9 !"#\u00A4%&\'()*+,-./0123456789:;<=>?\u00A1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00C4\u00D6\u00D1\u00DC\u00A7\u00BFabcdefghijklmnopqrstuvwxyz\u00E4\u00F6\u00F1\u00FC\u00E0';
const GSM_7_EXTENDED_CHARS = '^{}\\[~]|\u20AC';
const GSM_7_ALLOWED_CHARS = new Set([...GSM_7_BASIC_CHARS, ...GSM_7_EXTENDED_CHARS]);

const isSmsMessageCharsetSupported = (message) =>
  [...message].every((char) => GSM_7_ALLOWED_CHARS.has(char));

export const validateSmsMessage = (message) => {
  if (!message) {
    return 'Message should not be empty';
  }

  const normalized = message.normalize('NFKC');

  if ([...normalized].length > MAX_SMS_MESSAGE_LENGTH) {
    return `Message exceeds ${MAX_SMS_MESSAGE_LENGTH} characters.`;
  }

  if (!isSmsMessageCharsetSupported(normalized)) {
    return 'Message contains unsupported characters; please remove emojis/special symbols.';
  }

  return '';
};
